import React from 'react';
import ArrModal from '../../../common/arr-modal/ArrModal';

import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import './StylesHeatedMap.scss';
import ArrTextArea from '../../../common/arr-text-area/ArrTextArea';
import './ApplyKeywordModal.scss';
interface IApplyKeywordModalProps {
  open: boolean;
  setOpen: (isApplying: boolean) => void;
  keyword: string;
  setKeyword: (keyword: string) => void;
  handleApply: () => void;
}

const ApplyKeywordModal = ({
  open,
  setOpen,
  keyword,
  setKeyword,
  handleApply,
}: IApplyKeywordModalProps) => {
  const handleKeywordChange = (newValue: string) => {
    setKeyword(newValue);
  };

  const handleCancel = () => {
    setOpen(false);
    setKeyword('');
  };
  return (
    <ArrModal
      showModal={open}
      onClose={handleCancel}
      className="apply-keyword-modal"
      dataTestId="apply-keyword-modal"
      buttons={[
        {
          id: '1',
          label: t('common.cancel'),
          onClick: handleCancel,
          variant: 'secondary',
          dataTestId: 'copy-modal-confirm-btn',
        },
        {
          id: '2',
          label: t('common.ok').toUpperCase(),
          onClick: handleApply,
          variant: 'primary',
          dataTestId: 'copy-modal-confirm-btn',
          disabled: !keyword.trim().length,
        },
      ]}
      autoFocusCloseButton={true}
    >
      <Box className="modal-container">
        <Typography
          className="typo-text headline3_size text-headings"
          tabIndex={0}
          data-testid={`apply-keyword-modal-keyword-text-box-title`}
        >
          {t('reports.dataAnalysisReport.conceptExplorer.keywordTextBoxTitle')}
        </Typography>
        <ArrTextArea
          value={keyword}
          onChange={handleKeywordChange}
          placeholder={t(
            'reports.dataAnalysisReport.conceptExplorer.keywordTextBoxPlaceholder'
          )}
          isResponsive={false}
          className="keyword-text-area"
          dataTestId={`text-area-apply-keyword`}
        />
      </Box>
    </ArrModal>
  );
};

export default ApplyKeywordModal;
